import { useCallback, useMemo } from 'react';

import { useGraphql } from '../graphql';
import { useLoad } from '../load';

// One invitation to the signed-in patient, by its id. The answer is the
// invitation while it is open to them and null otherwise (answered,
// withdrawn, expired or sent to another address), which the screen shows
// as no longer open. data is undefined until the answer arrives or when it
// failed; error and retry are useLoad's.
export function useInvitation(id) {
  const graphql = useGraphql();

  const read = useCallback(function() {
    return graphql({
      document: `query Invitation($id: ID!) {
        invitation(id: $id) { id email sentAt clinician { firstName lastName } }
      }`,
      variables: { id }
    }).then(function(data) {
      return data.invitation;
    });
  }, [ graphql, id ]);

  const { data, error, retry } = useLoad(read);

  return useMemo(function() {
    return { invitation: data, error, retry };
  }, [ data, error, retry ]);
}
